"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFakeSupplySubAccount = exports.generateFakeDemandSubAccount = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const api_models_1 = require("@portal/api-models");
faker_1.default.seed(718);
const generateFakeDemandSubAccount = () => {
    const name = faker_1.default.company.companyName();
    return {
        accountId: faker_1.default.datatype.number({ min: 1 }),
        accountUuid: faker_1.default.datatype.uuid(),
        coBrand: false,
        companyUuid: faker_1.default.datatype.uuid(),
        createdAt: faker_1.default.date.past().toISOString(),
        createdBy: faker_1.default.datatype.uuid(),
        dataShare: api_models_1.DataShareType.Ineligible,
        description: faker_1.default.lorem.sentence(),
        disclaimer: faker_1.default.lorem.sentence(),
        displayName: name,
        id: faker_1.default.datatype.number({ min: 1 }),
        imageUrl: faker_1.default.image.imageUrl(),
        name,
        notes: faker_1.default.lorem.sentence(),
        productType: faker_1.default.lorem.word(),
        subAccountTypeKey: 'demand_source',
        supportsPreSelect: false,
        updatedAt: faker_1.default.date.recent().toISOString(),
        updatedBy: faker_1.default.datatype.uuid(),
        uuid: faker_1.default.datatype.uuid(),
    };
};
exports.generateFakeDemandSubAccount = generateFakeDemandSubAccount;
const generateFakeSupplySubAccount = () => {
    let howManySupplySubAccounts = faker_1.default.datatype.number({ max: 5, min: 1 });
    if (howManySupplySubAccounts === 0) {
        return [];
    }
    const supplySubAccounts = [];
    while (howManySupplySubAccounts > 0) {
        const name = faker_1.default.company.companyName();
        supplySubAccounts.push({
            accountId: faker_1.default.datatype.number(),
            accountUuid: faker_1.default.datatype.uuid(),
            coBrand: faker_1.default.datatype.boolean(),
            companyUuid: faker_1.default.datatype.uuid(),
            createdAt: faker_1.default.date.past().toISOString(),
            createdBy: faker_1.default.datatype.uuid(),
            dataShare: faker_1.default.helpers.arrayElement([
                api_models_1.DataShareType.Eligible,
                api_models_1.DataShareType.Ineligible,
            ]),
            displayName: name,
            id: faker_1.default.datatype.number(),
            imageUrl: faker_1.default.image.imageUrl(),
            name,
            subAccountOwners: {
                createdAt: faker_1.default.date.recent().toISOString(),
                createdBy: faker_1.default.datatype.uuid(),
                id: faker_1.default.datatype.number(),
                subAccountId: faker_1.default.datatype.number(),
            },
            subAccountTypeKey: 'supply_source',
            supportsPreSelect: faker_1.default.datatype.boolean(),
            updatedAt: faker_1.default.date.recent().toISOString(),
            updatedBy: faker_1.default.datatype.uuid(),
            uuid: faker_1.default.datatype.uuid(),
        });
        howManySupplySubAccounts--;
    }
    return supplySubAccounts;
};
exports.generateFakeSupplySubAccount = generateFakeSupplySubAccount;
